// Global search (ADO-7600 G-29): GET api/v3/pro/search/all — S&R, RQ, UQ and appointments
// in one paginated list. Every call resolves to { ok, body, paging, message }, never throws.
import { apiCall } from "./apiCall";
import { rqStatusColor } from "./rqApi";

// 1: any single character searches (the API still asks for 2 — G-82)
export const SEARCH_MIN_LENGTH = 1;
export const SEARCH_MAX_LENGTH = 200;

// Filter pills; `types` is sent as types[] (axios serialises arrays with brackets). Empty = all types.
export const SEARCH_TYPE_FILTERS = [
  { key: "all", text: "All", types: [] },
  { key: "sar", text: "Service & Repair", types: ["sar"] },
  { key: "rq", text: "Replacement Quotes", types: ["rq"] },
  { key: "uq", text: "Universal Quotes", types: ["uq"] },
  { key: "appointment", text: "Appointments", types: ["appointment"] },
  // "Consumers" removed: backend dropped consumer results from search/all (8ba1c04df7, 19 Oct)
  // Plan Sales / Plans / Bundles removed (user, 20 Oct): global search covers work orders only (backend gap G-48)
];

// "All" = every work-order type explicitly, so search/all can't return protection plans / sales / bundles
const ALL_TYPES = ["sar", "rq", "uq", "appointment"];

export const searchApi = {
  // body GlobalSearchItemResource[] + paging { total_records, current_page, total_pages, limit }
  all: ({ search, types = [], page = 1, limit = 25 }) => {
    const params = { search, page, limit, types: types.length ? types : ALL_TYPES };
    return apiCall("get", "search/all", params);
  },
};

// Same badge colours as the Service & Repair listing (customTable.vue); other statuses fall back to the RQ colours
const SAR_COLORS = {
  "EN ROUTE": "#65B741",
  "PENDING": "#F39C12",
  "CANCELLED": "#D7385E",
  "NO SALE": "#CA6180",
  "NEW SYSTEM": "#1D5D9B",
  "PAYMENT PENDING": "#F59E0B",
  "ARRIVED": "#635985",
  "CONVERTED TO BOOKING": "#635985",
  "CLOSED": "#686D76",
  "COMPLETED": "#65B741",
  "EVALUATION STARTED": "#5E366A",
  "STARTED": "#03AED2",
  "SUSPENDED": "#B91C1C",
  "EVALUATION COMPLETED": "#65B741",
  "ACCEPTED": "#7695FF",
  "CONSUMER QUOTE DECLINE": "#D7385E",
};

export function searchStatusColor(text) {
  return SAR_COLORS[String(text || "").toUpperCase()] || rqStatusColor(text);
}
